import React from 'react'
import { useError, useState, useEffect, useRef } from 'hooks'
import { EMAIL_REGEX } from 'common/constants'
import { inputType } from 'common/types'
import Icon from 'components/Icon'
import StyledInput, { StyledErrorInput, StyledPasswordInput } from './StyledInput'

const EMAIL = EMAIL_REGEX.source
const persist = fn => e => (e.persist(), fn(e))

const BasicInput = ({ onChange, innerRef, ...props }) => {
  props.type == 'email' && (props.pattern = EMAIL)

  return <StyledInput ref={innerRef} onChange={persist(onChange)} {...props} />
}

const ErrorInput = ({ error: { field = '', position } = {}, inline, onChange, name, ...rest }) => {
  const [error, _onChange] = useError(field || name, onChange)

  return (
    <StyledErrorInput position={position} inline={inline}>
      <BasicInput className={error ? 'error' : ''} onChange={_onChange} name={name} {...rest} />
      {error && <div className="errorMsg">{error}</div>}
    </StyledErrorInput>
  )
}

export const PasswordInput = props => {
  const [visible, setVisible] = useState(false)
  const innerRef = useRef(null)

  useEffect(() => {
    const input = innerRef.current
    if (input && props.autoFocus) {
      input.focus()
      const end = input.value.length
      input.setSelectionRange?.(end, end)
    }
  }, [visible])

  return (
    <StyledPasswordInput>
      <Input innerRef={innerRef} minLength={6} {...props} type={visible ? 'text' : 'password'} />
      <a href="#" onClick={e => (e.preventDefault(), setVisible(!visible))}>
        <Icon name={`eye${visible ? '' : '-slash'}`} />
      </a>
    </StyledPasswordInput>
  )
}

const Input = ({ hasError, ...props }) => (hasError ? <ErrorInput {...props} /> : <BasicInput {...props} />)

Input.propTypes = inputType

Input.defaultProps = {
  onChange: () => {},
  spellCheck: false,
}

export default Input
